import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Firestore } from '@angular/fire/firestore';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { SubscribeService } from '../services/subscribe.service';
import { SubscribeRequest } from '../models/subscribe-request.model';
import { MarketingConsentDialogComponent } from '../marketing-consent-dialog/marketing-consent-dialog.component';

@Component({
  selector: 'app-subscribe',
  templateUrl: './subscribe.component.html',
  styleUrls: ['./subscribe.component.scss'],
})
export class SubscribeComponent {
  subscribeForm: FormGroup;
  isSubmitting = false;
  isSubmitted = false;
  captchaResponse: string | null = null;
  errorMessage = '';

  constructor(
    private fb: FormBuilder,
    private firestore: Firestore,
    private router: Router,
    private dialog: MatDialog,
    private subscribeService: SubscribeService
  ) {
    this.subscribeForm = this.fb.group({
      name: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      marketingConsent: [false],
    });
  }

  async onSubmit() {
    if (this.subscribeForm.invalid) return;

    const formData = this.subscribeForm.value;

    // ✅ Ha nincs bejelölve a marketing consent, akkor kérdezzünk rá:
    if (!formData.marketingConsent) {
      const dialogRef = this.dialog.open(MarketingConsentDialogComponent, {
        width: '400px',
        panelClass: 'rounded-xl',
      });

      const result = await dialogRef.afterClosed().toPromise();

      // Ha "mégis kérek értesítést" -> jelöljük be automatikusan
      if (result === true) {
        this.subscribeForm.patchValue({ marketingConsent: true });
      }
    }

    // folytatjuk a mentést
    await this.submitSubscription();
  }

  private submitSubscription() {
    const formData = this.subscribeForm.value;
    const normalizedEmail = formData.email.trim().toLowerCase();

    this.isSubmitting = true;
    this.errorMessage = '';

    const request: SubscribeRequest = {
      name: formData.name,
      email: normalizedEmail,
      marketingConsent: formData.marketingConsent,
    };

    this.subscribeService.subscribe(request).subscribe({
      next: () => {
        this.isSubmitted = true;
        this.subscribeForm.reset();
        this.router.navigate(['/thanks']);
      },
      error: (err: any) => {
        this.errorMessage = err.message || 'Hiba történt a feliratkozás közben.';
        this.isSubmitting = false;
      },
    });
  }

  onCaptchaResolved(captchaResponse: string) {
    this.captchaResponse = captchaResponse;
  }
}
